import { FC, ReactNode } from 'react';

import { Box, Stack, Stretch } from '@eneco/sparky';
import {
  BoilerIcon,
  ElectricityIcon,
  GasIcon,
  GiftIcon,
  HappyPowerIcon,
  LabelIcon,
  RedeliveryIcon,
  RentalDeviceIcon,
  SolarPanelIcon,
  SourceHeatIcon,
  ToonIcon,
  ToonServiceIcon,
  WarmthIcon,
  WaterColdIcon,
  WaterWarmIcon,
} from '@eneco/sparky/icons';
import { BoxProps, IconProps } from '@eneco/sparky/types';
import { DC_Domain_Models_Products_ProductType } from '@monorepo-types/dc';

type Props = {
  className?: string;
  type?: Partial<DC_Domain_Models_Products_ProductType> | 'redelivery' | 'water';
  withBackground?: boolean;
};

const ProductIcon: FC<Props & IconProps> = ({ type, withBackground, className, ...iconProps }) => {
  let iconConfig: { icon: ReactNode; backgroundColor: BoxProps['backgroundColor'] };

  switch (type) {
    case 'bronwarmte':
      iconConfig = { icon: <SourceHeatIcon {...iconProps} />, backgroundColor: 'backgroundSecondary' };
      break;
    case 'electricity':
      iconConfig = {
        icon: <ElectricityIcon color="iconElectricity" {...iconProps} />,
        backgroundColor: 'backgroundVarFive',
      };
      break;
    case 'gas':
      iconConfig = { icon: <GasIcon color="iconGas" {...iconProps} />, backgroundColor: 'backgroundVarOne' };
      break;
    case 'happypower':
      iconConfig = {
        icon: <HappyPowerIcon {...iconProps} />,
        backgroundColor: 'backgroundSecondary',
      };
      break;
    case 'ketelComfort':
      iconConfig = { icon: <BoilerIcon {...iconProps} />, backgroundColor: 'backgroundSecondary' };
      break;
    case 'huurapparaat':
      iconConfig = {
        icon: <RentalDeviceIcon {...iconProps} />,
        backgroundColor: 'backgroundSecondary',
      };
      break;
    case 'solarPanels':
      iconConfig = { icon: <SolarPanelIcon color="iconSolar" {...iconProps} />, backgroundColor: 'backgroundVarSix' };
      break;
    case 'redelivery':
      iconConfig = { icon: <RedeliveryIcon color="iconSolar" {...iconProps} />, backgroundColor: 'backgroundVarSix' };
      break;
    case 'tapwater':
      iconConfig = { icon: <WaterWarmIcon color="iconWater" {...iconProps} />, backgroundColor: 'backgroundVarThree' };
      break;
    case 'water':
      iconConfig = { icon: <WaterColdIcon color="iconWater" {...iconProps} />, backgroundColor: 'backgroundVarThree' };
      break;
    case 'toon':
      iconConfig = {
        icon: <ToonIcon {...iconProps} />,
        backgroundColor: 'backgroundSecondary',
      };
      break;
    case 'toonservice':
      iconConfig = {
        icon: <ToonServiceIcon {...iconProps} />,
        backgroundColor: 'backgroundSecondary',
      };
      break;

    case 'cashback':
      iconConfig = {
        icon: <GiftIcon {...iconProps} color="iconHeat" />,
        backgroundColor: 'backgroundVarTwo',
      };
      break;
    case 'warmth':
      iconConfig = { icon: <WarmthIcon color="iconHeat" {...iconProps} />, backgroundColor: 'backgroundVarTwo' };
      break;

    default:
      iconConfig = {
        icon: <LabelIcon {...iconProps} />,
        backgroundColor: 'backgroundSecondary',
      };
      break;
  }

  return withBackground ? (
    <Box className={className} padding={4} backgroundColor={iconConfig.backgroundColor}>
      <Stretch>
        <Stack alignX="center" alignY="center">
          {iconConfig.icon}
        </Stack>
      </Stretch>
    </Box>
  ) : (
    iconConfig.icon
  );
};

export default ProductIcon;
